"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomWebsocketMessageSender = void 0;
/* eslint-disable complexity */
/* eslint-disable no-param-reassign */
var base_1 = require("../base");
var room_websocket_1 = require("./websocket/room-websocket");
var util_1 = require("../util");
var room_channel_define_1 = require("./room-channel-define");
var room_util_1 = require("./room-util");
var room_error_code_1 = require("./room-error-code");
var controller_1 = require("../controller");
var collab_room_reporter_1 = __importDefault(require("../report/collab-room-reporter"));
var interface_1 = require("../interface");
var room_websocket_message_queue_1 = require("./room-websocket-message-queue");
var feature_1 = require("../feature");
var RoomWebsocketMessageSender = /** @class */ (function () {
    function RoomWebsocketMessageSender(channelOption, controllerDependency, channelDependency) {
        var _this = this;
        var _a, _b;
        this.reconnectTimes = []; // 每次reopen时间，open后清空
        this.liteReconnects = 0; // reopen次数，open后清空
        this.socketDisconnectTimer = 0; // Disconnect 后，等待一段时间 15s，关闭room
        this.reopenDelayTimer = 0; // close 后，启动定时器，随机delay一段时间，reopen room
        this.websocketDisconneted = false; // websocket disconnected, websocket 内部重连
        this.hasSocketReconnected = false;
        this.messageSenderTimer = 0; // 消息发送定时器
        this.channelOption = channelOption;
        this.controllerDependency = controllerDependency;
        this.roomChannelDependency = channelDependency;
        this.roomMsgQueue = new room_websocket_message_queue_1.RoomWebsocketMessageQueue(this);
        this.limitFrequencyManager = new feature_1.LimitFrequencyManager(this.controllerDependency);
        (_b = (_a = this.channelOption.config) === null || _a === void 0 ? void 0 : _a.messagePriority) === null || _b === void 0 ? void 0 : _b.forEach(function (value, key) {
            _this.limitFrequencyManager.setPriority(key, value);
        });
    }
    RoomWebsocketMessageSender.prototype.dispose = function () {
        var _a, _b;
        (_a = this.roomWebsocket) === null || _a === void 0 ? void 0 : _a.dispose();
        this.roomMsgQueue.dispose();
        this.clearSocket();
        (_b = this.limitFrequencyManager) === null || _b === void 0 ? void 0 : _b.dispose();
    };
    RoomWebsocketMessageSender.prototype.openWebsocketConnection = function () {
        if (this.isConnected()) {
            util_1.ConnectionLog.warn('openWebsocketConnection: already exist.');
            return;
        }
        if (this.roomChannelDependency.getRoomState() === room_channel_define_1.RoomState.SHUTDOWN) {
            util_1.ConnectionLog.error('openWebsocketConnection: room state shut down.');
            return;
        }
        this.createWebsocketAndConnect();
    };
    RoomWebsocketMessageSender.prototype.isConnected = function () {
        var _a, _b;
        return !this.websocketDisconneted && ((_b = (_a = this.roomWebsocket) === null || _a === void 0 ? void 0 : _a.isConnected()) !== null && _b !== void 0 ? _b : false);
    };
    RoomWebsocketMessageSender.prototype.shutDown = function (reason) {
        var _a;
        util_1.ConnectionLog.info("shutDown, close reason: " + reason.reason + ", errCode:" + reason.errCode);
        reason.reason = (_a = reason.reason) !== null && _a !== void 0 ? _a : 'close by client.';
        this.clearSocket();
        reason.shutDown = true;
        this.notifyRoomClosed(reason, 0);
    };
    RoomWebsocketMessageSender.prototype.sendMessage = function (msg) {
        // 参数校验  onsendAccept 必须要有waitAcceptCmd 数组
        if (util_1.isInvalidWaitAcceptCmd(msg)) {
            util_1.ConnectionLog.error('sendMessage: waitAcceptCmd params invalid!');
            this.doErrorCallback(msg, {
                errCode: room_error_code_1.RoomErrorCode.PARA_ERROR,
                errMsg: 'msg param invalid.',
            });
        }
        else if (this.roomChannelDependency.getRoomState() !== room_channel_define_1.RoomState.OPENED) {
            var roomState = this.roomChannelDependency.getRoomState();
            util_1.ConnectionLog.warn("sendMessage: room state error, state = " + roomState + "!");
            if (this.needReopen()) {
                this.reopen();
            }
            this.doErrorCallback(msg, {
                errCode: roomState === room_channel_define_1.RoomState.SHUTDOWN ? room_error_code_1.RoomErrorCode.ROOM_SHUTDOWN : room_error_code_1.RoomErrorCode.ROOM_STATE_ERR,
                errMsg: 'can not send message in this room state.',
            });
        }
        else {
            // 进入消息队列
            this.sendMessageInternal(msg);
        }
    };
    RoomWebsocketMessageSender.prototype.cancelSendMessageByTaskId = function (seq) {
        var msg = this.roomMsgQueue.cancelMessage(seq);
        if ((msg === null || msg === void 0 ? void 0 : msg.state) === room_channel_define_1.MessageState.SENDING) {
            this.startMessageSending();
        }
    };
    /**
     *  使用 Websocket 发送消息(序列化后)
     *
     * @param {string} data
     */
    RoomWebsocketMessageSender.prototype.postMessageWithWebsocket = function (data) {
        var _a;
        (_a = this.roomWebsocket) === null || _a === void 0 ? void 0 : _a.postMessageForWebSocket(data);
    };
    RoomWebsocketMessageSender.prototype.createPostData = function (cmd, seq, body, additionalFieldsToHead) {
        var _a, _b;
        var sessionType = Number(this.channelOption.userId.startsWith('g')); // g开头是访客
        var uid = this.channelOption.uid || this.channelOption.userId.replace('p.', '').replace('g.', '');
        var head = {
            apid: this.channelOption.apId,
            type: cmd,
            task_id: seq,
            docid: this.channelOption.globalPadId,
            uid: uid,
            cookie: util_1.getCookieForMessage(),
            base_rev: typeof body === 'object' && typeof body.baseRev === 'number'
                ? body.baseRev
                : this.controllerDependency.getVersion(),
            code_ver: this.channelOption.codeVer,
            session_type: sessionType,
            gray: this.channelOption.gray,
            dver: this.channelOption.dver,
            wl: util_1.Cookie.get('wl'),
            u: this.channelOption.nowUserIndex,
            generalpacket: this.controllerDependency.getHeaderGeneralPacket(),
            docs_type: this.channelOption.padType,
        };
        // 强制使用 websocket，不触发 60034
        if (((_a = this.channelOption.config) === null || _a === void 0 ? void 0 : _a.connectMode) === controller_1.ConnectMode.WEBSOCKET_FORCED) {
            head.model = 'websocket';
        }
        // 将业务侧字段携带到 head里，注意之类，仅做浅拷贝
        head = Object.assign(additionalFieldsToHead !== null && additionalFieldsToHead !== void 0 ? additionalFieldsToHead : {}, head);
        var data = util_1.JsonUtil.jsonStringify(head) + "\n";
        data += (_b = interface_1.prepareCommitMessage(body, this.channelOption.uuId, this.channelOption.pver)) !== null && _b !== void 0 ? _b : '';
        return data;
    };
    RoomWebsocketMessageSender.prototype.startMessageSending = function () {
        if (this.roomMsgQueue.messageCount() > 0) {
            this.trySendPendingMessage();
        }
    };
    RoomWebsocketMessageSender.prototype.notifyRoomOpened = function () {
        this.limitFrequencyManager.reset();
    };
    RoomWebsocketMessageSender.prototype.closeAndDelayReopen = function (reason, delayOpenTime) {
        var _a;
        reason.reason = (_a = reason.reason) !== null && _a !== void 0 ? _a : 'close by client.';
        util_1.ConnectionLog.info("closeAndDelayReopen: close reason = " + reason.reason + ", delay time = " + delayOpenTime);
        this.clearSocket();
        reason.shutDown = false;
        this.notifyRoomClosed(reason, delayOpenTime);
    };
    /* IRoomWebSocketDependency begin */
    RoomWebsocketMessageSender.prototype.onSocketStatusChanged = function (channelInfo) {
        if (!channelInfo.event) {
            util_1.ConnectionLog.warn('onSocketStatusChanged: channel info error.');
            return;
        }
        if (channelInfo.event !== "open" /* open */
            && this.roomChannelDependency.getRoomState() !== room_channel_define_1.RoomState.SHUTDOWN) {
            this.roomChannelDependency.roomStateReconnecting();
        }
        this.handleSocketStatusChangeEvent(channelInfo);
    };
    RoomWebsocketMessageSender.prototype.onGetMessageFromServerPush = function (msgData) {
        var dataList = msgData.split('\r\n'); // 批量数据，数组
        if (!(dataList instanceof Array)) {
            util_1.ConnectionLog.error('onGetMessageFromServer: message data error.');
            return;
        }
        this.parseGetMsgDataList(dataList);
    };
    RoomWebsocketMessageSender.prototype.onPostFromServer = function (msgData) {
        var messageList = msgData.split('\n'); // head+body的数据
        var _a = __read(messageList.map(function (item) { return util_1.JsonUtil.parseJson(item); }), 2), head = _a[0], body = _a[1];
        if (!(head && body)) {
            util_1.ConnectionLog.error('onPostFromServer: message data parsed error.');
            return;
        }
        if (head.type === "HEART_BEAT" /* HEART_BEAT */) {
            this.roomChannelDependency.onHeartBeatResponse(head, body);
            return;
        }
        if (head.type === "CLIENT_READY" /* CLIENT_READY */) {
            this.roomChannelDependency.onLoginResponse(head, body);
            return;
        }
        this.parsePostCommonMessageFromServer(head, body);
    };
    RoomWebsocketMessageSender.prototype.onSocketOpen = function () {
        this.liteReconnects = 0;
        this.reconnectTimes = [];
        this.websocketDisconneted = false;
        this.hasSocketReconnected = false;
        util_1.ConnectionLog.info('onSocketOpenEvent');
        this.clearDisconnectTimer();
        this.clearReopenDelayTimer();
        this.roomChannelDependency.resetHeartBeat();
        this.roomChannelDependency.resetLogin();
        this.roomChannelDependency.loginRoom();
    };
    RoomWebsocketMessageSender.prototype.onSocketClosed = function (reason) {
        util_1.ConnectionLog.info('onSocketClosedEvent: socket closed!');
        this.roomWebsocket = null;
        this.notifyRoomClosed({ reason: reason, shutDown: false }, 0);
        if (this.hasSocketReconnected) {
            this.controllerDependency.networkReconnectedFail();
        }
    };
    RoomWebsocketMessageSender.prototype.onReopenCount = function () {
        return this.liteReconnects;
    };
    /* IRoomWebSocketDependency end */
    /* IRoomWebsocketMessageSenderDependency begin */
    RoomWebsocketMessageSender.prototype.doErrorCallback = function (msg, result) {
        msg.onError(msg.taskId, msg.cmd, msg.data, result);
    };
    RoomWebsocketMessageSender.prototype.reportMessage = function (msg, result) {
        var messageInfo = {
            cmd: msg.cmd,
            attrName: String(result.errCode),
            status: 1 /* FAILED */,
            module: this.channelOption.module,
            errorMessage: result.errMsg,
            waitAcceptCmd: result.waitAcceptCmd,
        };
        collab_room_reporter_1.default.commitError(messageInfo);
    };
    /* IRoomWebsocketMessageSenderDependency end */
    RoomWebsocketMessageSender.prototype.sendMessageInternal = function (message) {
        var _a, _b, _c, _d, _e, _f;
        if (this.roomMsgQueue.messageAlreadyExist(message)) {
            this.doErrorCallback(message, {
                errCode: room_error_code_1.RoomErrorCode.EXIST,
                errMsg: 'msg already exist.',
            });
            return;
        }
        var seq = message.taskId || util_1.generateMessageTaskId();
        var postData = this.createPostData(message.cmd, seq, message.data, message.additionalFieldsToHead);
        var waitCmd;
        if ((_a = message.customParam) === null || _a === void 0 ? void 0 : _a.waitAcceptCmd) {
            waitCmd = (_b = message.customParam) === null || _b === void 0 ? void 0 : _b.waitAcceptCmd;
        }
        var newMessage = room_util_1.RoomUtil.createNewMessage(seq, postData, (_d = (_c = message.customParam) === null || _c === void 0 ? void 0 : _c.timeout) !== null && _d !== void 0 ? _d : interface_1.DEFAULT_SEND_MESSAGE_TIMEOUT, (_f = (_e = message.customParam) === null || _e === void 0 ? void 0 : _e.maxRetryCount) !== null && _f !== void 0 ? _f : interface_1.DEFAULT_RETRY_COUNTS, message.cmd, message.data, waitCmd, message.onError, message.onsend, message.onsendAccept);
        this.roomMsgQueue.addWaittingMessage(newMessage);
        this.startMessageSending();
        this.startMessageTimer();
    };
    RoomWebsocketMessageSender.prototype.handleSocketStatusChangeEvent = function (channelInfo) {
        var _a;
        util_1.ConnectionLog.info("handleSocketStatusChangeEvent: " + channelInfo.event + " reason: " + ((_a = channelInfo.disconnectReason) !== null && _a !== void 0 ? _a : channelInfo.failReason));
        if (channelInfo.event === "reconnecting" /* reconnecting */) {
            // 重新连接
            this.hasSocketReconnected = true;
        }
        else if (channelInfo.event === "disconnect" /* disconnect */) {
            this.handleDisconnectEvent(channelInfo);
        }
    };
    RoomWebsocketMessageSender.prototype.createWebsocketAndConnect = function () {
        if (this.roomWebsocket) {
            util_1.ConnectionLog.warn('createWebsocketAndConnect:socket has exist');
            return;
        }
        var socketOptions = {
            padId: this.channelOption.padId,
            roomWebSocketDependency: this,
            tag: this.channelOption.padId,
            gid: this.channelOption.globalPadId,
            upid: this.channelOption.upid || '',
            sig: this.channelOption.sig,
            uid: this.channelOption.uid,
            uidKey: util_1.Cookie.get('uid_key'),
            wmode: this.channelOption.wmode,
            websocketReopenCount: this.channelOption.websocketReopenCount,
            pollingAttemptNumber: this.channelOption.pollingAttemptNumber,
            nowUserIndex: this.channelOption.nowUserIndex,
            module: this.channelOption.module,
            config: this.channelOption.config,
        };
        this.roomWebsocket = new room_websocket_1.RoomWebsocket(socketOptions);
        this.roomWebsocket.connect();
        this.setupSocketTime = room_util_1.RoomUtil.getCurrentTime();
    };
    RoomWebsocketMessageSender.prototype.clearSocket = function () {
        if (this.roomWebsocket) {
            this.roomWebsocket.disconnect('');
            this.clearDisconnectTimer();
        }
        this.roomWebsocket = null;
    };
    RoomWebsocketMessageSender.prototype.reopen = function () {
        util_1.ConnectionLog.info('reopen: socket reopen.');
        this.clearSocket();
        this.roomChannelDependency.resetHeartBeat();
        this.roomChannelDependency.resetLogin();
        this.openWebsocketConnection();
    };
    RoomWebsocketMessageSender.prototype.needReopen = function () {
        // 断网超过50s（底层最长 40s后就会触发重连）
        var roomState = this.roomChannelDependency.getRoomState();
        if (roomState === room_channel_define_1.RoomState.CONNECTING || roomState === room_channel_define_1.RoomState.RECONNECTING_IN_CLOSED) {
            var nowTime = room_util_1.RoomUtil.getCurrentTime();
            if (this.setupSocketTime && nowTime > this.setupSocketTime && nowTime - this.setupSocketTime > 50 * 1000) {
                return true;
            }
        }
        return false;
    };
    RoomWebsocketMessageSender.prototype.notifyRoomClosed = function (reason, delayOpenTime) {
        util_1.ConnectionLog.info("notifyRoomClosed: reason = " + reason.reason + ", shutdown = " + reason.shutDown);
        this.clearDisconnectTimer();
        this.websocketDisconneted = true;
        this.roomChannelDependency.resetHeartBeat();
        this.roomChannelDependency.resetLogin();
        this.roomChannelDependency.onRoomClosed(reason);
        // 房间状态变化后再处理队列里的消息回调
        this.roomMsgQueue.handleMessageQueueByRoomClose(reason.shutDown);
        // 关闭不再重连 shutdown
        if (reason.shutDown) {
            this.reset();
            this.clearMessageSenderTimer();
        }
        else {
            this.delayReopen(delayOpenTime);
        }
    };
    RoomWebsocketMessageSender.prototype.delayReopen = function (delayOpenTime) {
        var _this = this;
        if (this.reopenDelayTimer) {
            return;
        }
        this.reconnectTimes.push(room_util_1.RoomUtil.getCurrentTime());
        this.liteReconnects += 1;
        var delayTime = delayOpenTime;
        if (!delayOpenTime) {
            // 根据次数计算delay时间
            delayTime = Math.min(30000, 1000 * Math.pow(2, (this.liteReconnects + 1)));
            delayTime = this.generateFuzzyInterval(delayTime, delayTime * 0.4);
        }
        this.reopenDelayTimer = setTimeout(function () {
            _this.clearReopenDelayTimer();
            _this.roomChannelDependency.openRoom();
        }, delayTime);
    };
    RoomWebsocketMessageSender.prototype.generateFuzzyInterval = function (targetInterval, maxFuzz) {
        return targetInterval + Math.floor(Math.random() * (2 * maxFuzz + 1) - maxFuzz);
    };
    RoomWebsocketMessageSender.prototype.reset = function () {
        this.roomWebsocket = null;
        this.liteReconnects = 0;
        this.reconnectTimes = [];
        this.clearDisconnectTimer();
        this.clearReopenDelayTimer();
        this.roomChannelDependency.resetLogin();
        this.roomChannelDependency.resetHeartBeat();
    };
    RoomWebsocketMessageSender.prototype.parsePostCommonMessageFromServer = function (head, body) {
        var msg = this.roomMsgQueue.getMessageByTaskId(head.task_id);
        if (msg && msg.cmd === head.type) {
            this.handleCommonMessage(msg, body);
            this.finishParseMessage(msg, body);
        }
        else {
            // 尝试在finish队列里找
            var finishedMsg = this.roomMsgQueue.getFinishedMessageByTaskId(head.task_id);
            if (!finishedMsg) {
                util_1.ConnectionLog.warn("parsePostCommonMessageFromServer: msg not found! seq = " + head.task_id + ", cmd = " + head.type);
            }
        }
        // 发送下一个
        this.startMessageSending();
        this.roomMsgQueue.clearFinishQueueIfNeed();
    };
    RoomWebsocketMessageSender.prototype.finishParseMessage = function (message, body) {
        var _a;
        var errCode = body.onpost.result;
        if (!((_a = message.waitAcceptCmd) === null || _a === void 0 ? void 0 : _a.length) || errCode !== 0) {
            // 不需要等待 accept, 或者回包出错， 删除移到finish 队列
            this.roomMsgQueue.addFinishMessage(message);
        }
        else {
            // 状态修改为waitAccept 需要解析
            message.state = room_channel_define_1.MessageState.WAIT_ACCEPT;
        }
        // 发送下一个
        this.startMessageSending();
    };
    RoomWebsocketMessageSender.prototype.handleCommonMessage = function (msg, body) {
        msg.onpostTime = room_util_1.RoomUtil.getCurrentTime();
        var errCode = body.onpost.result;
        var retryInterval = body.onpost.retry_interval; // 重试的时间间隔（毫秒）
        if (errCode !== room_error_code_1.RoomWebsocketErrorCode.SOCKET_SERVER_SUCCESS) {
            util_1.ConnectionLog.error("handleCommonMessage: server response error, code = " + errCode);
        }
        this.reportMsgParseErrorIfNeed(errCode, msg, body);
        if (errCode === room_error_code_1.RoomWebsocketErrorCode.SOCKET_SERVER_ERROR
            || errCode === room_error_code_1.RoomWebsocketErrorCode.SOCKET_USER_AUTH_FAILED) {
            this.shutDown({ errCode: errCode, reason: room_util_1.RoomUtil.getWebsocketChannelErrorMessage(errCode), shutDown: true });
            return;
        }
        if (errCode === room_error_code_1.RoomWebsocketErrorCode.SOCKET_LAYER_ERROR) {
            this.closeAndDelayReopen({ errCode: errCode, reason: room_util_1.RoomUtil.getWebsocketChannelErrorMessage(errCode), shutDown: false }, retryInterval);
            return;
        }
        var rspBody = {
            errCode: errCode,
            errMsg: '',
            response: body,
        };
        if (errCode === room_error_code_1.RoomWebsocketErrorCode.SOCKET_SERVER_SUCCESS) {
            this.doMsgOnSendSuccessCallback(msg, rspBody);
        }
        else {
            this.doErrorCallback(msg, rspBody);
        }
    };
    RoomWebsocketMessageSender.prototype.reportMsgParseErrorIfNeed = function (errCode, msg, body) {
        if (errCode !== room_error_code_1.RoomWebsocketErrorCode.SOCKET_SERVER_SUCCESS) {
            var result = {
                errCode: errCode,
                errMsg: room_util_1.RoomUtil.getWebsocketChannelErrorMessage(errCode),
                event: room_channel_define_1.MessageResultEvent.ON_POST,
                response: body,
                needRetry: false,
            };
            this.reportMessage(msg, result);
        }
    };
    // 取出第一个waiting状态的消息并发送
    RoomWebsocketMessageSender.prototype.trySendPendingMessage = function () {
        if (this.needReopen()) {
            this.reopen();
            return;
        }
        if (!this.readyToSendMessage())
            return;
        this.sendWaitingMessage();
    };
    RoomWebsocketMessageSender.prototype.sendWaitingMessage = function () {
        var msg = this.roomMsgQueue.getFirstWaittingMessage();
        if (!msg)
            return;
        this.postOneMessage(msg);
        this.startMessageTimer();
    };
    RoomWebsocketMessageSender.prototype.postOneMessage = function (msg) {
        this.preparePostMessage(msg);
        this.postMessageWithWebsocket(msg.postData);
    };
    RoomWebsocketMessageSender.prototype.preparePostMessage = function (msg) {
        if (msg.retryCount === 0 || !msg.firstSendTime) {
            msg.firstSendTime = room_util_1.RoomUtil.getCurrentTime();
        }
        msg.retryCount += 1;
        msg.lastSendTime = room_util_1.RoomUtil.getCurrentTime();
        msg.onpostTime = 0;
        msg.state = room_channel_define_1.MessageState.SENDING;
    };
    RoomWebsocketMessageSender.prototype.startMessageTimer = function () {
        var _this = this;
        if (!this.messageSenderTimer) {
            this.messageSenderTimer = setTimeout(function () {
                _this.handleMessageTimer();
            }, 1000);
        }
    };
    RoomWebsocketMessageSender.prototype.handleMessageTimer = function () {
        this.clearMessageSenderTimer();
        var needToSendNextMsg = this.roomMsgQueue.processMessageQueue();
        if (this.roomMsgQueue.messageCount() > 0) {
            if (needToSendNextMsg) {
                this.startMessageSending();
            }
            this.startMessageTimer();
        }
    };
    RoomWebsocketMessageSender.prototype.readyToSendMessage = function () {
        if (!(this.roomChannelDependency.getRoomState() === room_channel_define_1.RoomState.OPENED && this.isConnected())) {
            util_1.ConnectionLog.warn("readyToSendMessage: roomstate = " + this.roomChannelDependency.getRoomState() + ", websocket connected = " + this.isConnected());
            return false;
        }
        return this.roomMsgQueue.readyToSendMessage();
    };
    RoomWebsocketMessageSender.prototype.handleMessageErrorCode = function (code, reason) {
        var messageInfo = {
            attrName: String(code),
            status: 1 /* FAILED */,
            module: this.channelOption.module,
            errorMessage: room_util_1.RoomUtil.getWebsocketChannelErrorMessage(code),
        };
        this.shutDown({ reason: reason, errCode: code, shutDown: true });
        collab_room_reporter_1.default.shutDownReport(messageInfo);
    };
    RoomWebsocketMessageSender.prototype.receiveMessageFromServer = function (head, body) {
        var _a;
        // 非消息队列里的消息，透传给上层处理
        var msgData = {
            head: head,
            body: body,
            newRev: head.new_rev,
            ts: head.ts,
            socketId: ((_a = this.roomWebsocket) === null || _a === void 0 ? void 0 : _a.socketId) || '',
            needDeal: true,
        };
        this.limitFrequencyManager.handleMessage(msgData);
        if (msgData.needDeal) {
            this.controllerDependency.receiveMessageFromServer(head.type, [msgData]);
        }
    };
    RoomWebsocketMessageSender.prototype.handleWaitAcceptMessage = function (head, body) {
        var msg = this.roomMsgQueue.getMessageByTaskId(head.task_id);
        if (msg) {
            if (this.processWaitAcceptMessage(msg, head, body)) {
                this.roomMsgQueue.addFinishMessage(msg);
            }
            else {
                util_1.ConnectionLog.error("processWaitAcceptMessage: msg found but waitcmd not match. seq = " + msg.taskId + ", cmd = " + msg.cmd + ", wait cmd = " + head.type);
            }
        }
        else {
            msg = this.roomMsgQueue.getFinishedMessageByTaskId(head.task_id);
            if (!msg) {
                this.receiveMessageFromServer(head, body);
            }
        }
    };
    RoomWebsocketMessageSender.prototype.hasWaitAcceptCommand = function (message, type) {
        var _a;
        return !!((_a = message.waitAcceptCmd) === null || _a === void 0 ? void 0 : _a.includes(type));
    };
    RoomWebsocketMessageSender.prototype.processWaitAcceptMessage = function (message, head, body) {
        var _a, _b, _c, _d;
        if (this.hasWaitAcceptCommand(message, head.type)) {
            this.doMsgOnSendAcceptSuccessCallback(message, head, body);
            var result = {
                errCode: (_b = (_a = body.data) === null || _a === void 0 ? void 0 : _a.reason) !== null && _b !== void 0 ? _b : 0,
                errMsg: room_util_1.RoomUtil.getWebsocketChannelErrorMessage((_d = (_c = body.data) === null || _c === void 0 ? void 0 : _c.reason) !== null && _d !== void 0 ? _d : 0),
                waitAcceptCmd: head.type,
                event: room_channel_define_1.MessageResultEvent.ON_SEND_ACCEPT,
                response: body,
                needRetry: false,
            };
            this.reportMessage(message, result);
            return true;
        }
        return false;
    };
    RoomWebsocketMessageSender.prototype.parseGetMsgDataList = function (dataList) {
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (var index = 0; index < dataList.length; index++) {
            var data = dataList[index];
            var messageList = data.split('\n'); // head+body的数据
            if (messageList.length < 2) {
                util_1.ConnectionLog.error('onGetMessageFromServer: message data error.');
                return;
            }
            this.parseGetMsgList(messageList);
        }
    };
    RoomWebsocketMessageSender.prototype.parseGetMsgList = function (messageList) {
        var _a, _b;
        var _c = __read(messageList.map(function (item) { return util_1.JsonUtil.parseJson(item); }), 2), head = _c[0], body = _c[1];
        // 非活跃用户被踢
        if ((head === null || head === void 0 ? void 0 : head.type) === "QUIT_NOTICE" /* QUIT_NOTICE */ && Object.values(base_1.QUIT_TYPE).includes(body === null || body === void 0 ? void 0 : body.notice.quit_type)) {
            var quitTypeMap = new Map([
                [base_1.QUIT_TYPE.INACTIVE, { code: room_error_code_1.RoomWebsocketErrorCode.INACTIVE, reason: base_1.QUIT_TYPE.INACTIVE }],
                [base_1.QUIT_TYPE.LOGIN_INVALIDATE, { code: room_error_code_1.RoomWebsocketErrorCode.LOGIN_INVALIDATE, reason: base_1.QUIT_TYPE.LOGIN_INVALIDATE }],
                [base_1.QUIT_TYPE.LOGIN_FORBIDDEN, { code: room_error_code_1.RoomWebsocketErrorCode.LOGIN_FORBIDDEN, reason: base_1.QUIT_TYPE.LOGIN_FORBIDDEN }],
            ]);
            this.handleMessageErrorCode((_a = quitTypeMap.get(body === null || body === void 0 ? void 0 : body.notice.quit_type)) === null || _a === void 0 ? void 0 : _a.code, (_b = quitTypeMap.get(body === null || body === void 0 ? void 0 : body.notice.quit_type)) === null || _b === void 0 ? void 0 : _b.reason);
            return;
        }
        if (this.roomMsgQueue.messageCount() === 0) {
            // 尝试在finishQueue内查询处理
            this.processFinishedGetMsg(head, body);
            return;
        }
        this.handleWaitAcceptMessage(head, body);
    };
    RoomWebsocketMessageSender.prototype.processFinishedGetMsg = function (head, body) {
        // 不在消息队列也不在完成队列，透传给上层
        if (!this.roomMsgQueue.getFinishedMessageByTaskId(head.task_id)) {
            this.receiveMessageFromServer(head, body);
        }
    };
    RoomWebsocketMessageSender.prototype.handleDisconnectEvent = function (channelInfo) {
        var _this = this;
        // 断开连接
        if (!channelInfo.event)
            return;
        this.websocketDisconneted = true;
        if (!this.socketDisconnectTimer) {
            this.roomChannelDependency.resetLogin();
            this.roomChannelDependency.resetHeartBeat();
            this.roomMsgQueue.handleMsgBySocketDisconnect();
            // 25s后断开重连
            this.socketDisconnectTimer = setTimeout(function () {
                var _a, _b;
                if (!channelInfo.socketId && channelInfo.socketId === ((_a = _this.roomWebsocket) === null || _a === void 0 ? void 0 : _a.socketId)) {
                    _this.disConnect((_b = channelInfo.disconnectReason) !== null && _b !== void 0 ? _b : '');
                }
            }, 25000);
        }
    };
    RoomWebsocketMessageSender.prototype.clearDisconnectTimer = function () {
        if (this.socketDisconnectTimer) {
            clearTimeout(this.socketDisconnectTimer);
            this.socketDisconnectTimer = 0;
        }
    };
    RoomWebsocketMessageSender.prototype.clearReopenDelayTimer = function () {
        if (this.reopenDelayTimer) {
            clearTimeout(this.reopenDelayTimer);
            this.reopenDelayTimer = 0;
        }
    };
    RoomWebsocketMessageSender.prototype.clearMessageSenderTimer = function () {
        // reset 的时候不能清理 messageSenderTimer， 房间 open 时还需继续检查提交
        if (this.messageSenderTimer) {
            clearTimeout(this.messageSenderTimer);
            this.messageSenderTimer = 0;
        }
    };
    RoomWebsocketMessageSender.prototype.disConnect = function (reason) {
        util_1.ConnectionLog.info("disConnect, reason:" + reason);
        if (this.roomChannelDependency.getRoomState() === room_channel_define_1.RoomState.SHUTDOWN)
            return;
        this.clearSocket();
        this.notifyRoomClosed({ reason: "close by disconnect, reason " + reason, shutDown: false }, 0);
    };
    RoomWebsocketMessageSender.prototype.doMsgOnSendAcceptSuccessCallback = function (msg, head, body) {
        var _a, _b, _c, _d, _e;
        (_a = msg.onsendAccept) === null || _a === void 0 ? void 0 : _a.call(msg, msg.taskId, msg.cmd, msg.data, head.type, {
            errCode: (_c = (_b = body === null || body === void 0 ? void 0 : body.data) === null || _b === void 0 ? void 0 : _b.reason) !== null && _c !== void 0 ? _c : 0,
            errMsg: (_e = (_d = body === null || body === void 0 ? void 0 : body.data) === null || _d === void 0 ? void 0 : _d.msg) !== null && _e !== void 0 ? _e : '',
            response: {
                body: body,
                new_rev: head.new_rev,
            },
        });
    };
    RoomWebsocketMessageSender.prototype.doMsgOnSendSuccessCallback = function (msg, result) {
        var _a;
        (_a = msg.onsend) === null || _a === void 0 ? void 0 : _a.call(msg, msg.taskId, msg.cmd, msg.data, result);
    };
    return RoomWebsocketMessageSender;
}());
exports.RoomWebsocketMessageSender = RoomWebsocketMessageSender;
